// removed by extract-text-webpack-plugin
module.exports = {"Dropdown":"Dropdown","Disabled":"Disabled","DropdownToggle":"DropdownToggle","DropdownLogo":"DropdownLogo","Active":"Active","ActiveVcsc":"ActiveVcsc","DropdownMenu":"DropdownMenu","DropdownMenuVcsc":"DropdownMenuVcsc","dropdown-item":"dropdown-item","active":"active","DropdownItemVcsc":"DropdownItemVcsc","DropdownForm":"DropdownForm","DropdownEdit":"DropdownEdit"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Dropdown/styles.scss
// module id = 1849
// module chunks = 10